import type { SVGProps } from 'react';
const SvgArrowsLeftRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6.24 7.33-3.97 4.876c-.36.44-.36 1.153 0 1.588l3.97 4.875c.36.441.94.441 1.295 0 .355-.44.36-1.153 0-1.588L5.13 14.127h15.738l-2.406 2.954c-.36.44-.36 1.153 0 1.588.359.436.94.441 1.294 0l3.976-4.87c.359-.44.359-1.153 0-1.589l-3.972-4.88c-.359-.44-.94-.44-1.294 0-.355.441-.36 1.154 0 1.59l2.406 2.953H5.133L7.54 8.92c.36-.441.36-1.154 0-1.59-.359-.435-.94-.44-1.294 0z"
    />
  </svg>
);
export default SvgArrowsLeftRight;
